import * as React from "react"

const SvgPrint = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M8 21.571q-.824 0-1.412-.587A1.93 1.93 0 0 1 6 19.57v-2H4q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 15.57v-4q0-1.275.875-2.137C3.75 8.571 4.167 8.57 5 8.57h14q1.276 0 2.137.863.863.862.863 2.137v4a1.93 1.93 0 0 1-.587 1.413A1.93 1.93 0 0 1 20 17.57h-2v2a1.93 1.93 0 0 1-.587 1.413A1.93 1.93 0 0 1 16 21.57H8Zm-4-6h2q0-.825.588-1.412A1.93 1.93 0 0 1 8 13.57h8q.824 0 1.413.588.587.588.587 1.412h2v-4a.97.97 0 0 0-.288-.712.97.97 0 0 0-.712-.288H5a.97.97 0 0 0-.713.288.97.97 0 0 0-.287.712zm12-7v-3H8v3H6v-3q0-.824.588-1.412A1.93 1.93 0 0 1 8 3.57h8q.824 0 1.413.588Q18 4.746 18 5.57v3zm2 4.5q.424 0 .712-.287A.97.97 0 0 0 19 12.07a.97.97 0 0 0-.288-.712.97.97 0 0 0-.712-.288.97.97 0 0 0-.712.288.97.97 0 0 0-.288.712q0 .426.288.713a.96.96 0 0 0 .712.287Zm-2 6.5v-4H8v4z" />
  </svg>
)
export default SvgPrint
